import React from 'react';
import { motion } from 'framer-motion';
import { scrollToCheckout } from '../utils/scroll';
import { ChevronRight, Brain, Zap, Shield, Lock, Download, MapPin } from 'lucide-react';
export const HeroSection = () => {
  return <section className="pt-3 sm:pt-16 pb-4 sm:pb-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-186">
      {/* Title */}
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-[22px] sm:text-5xl md:text-6xl font-bold text-dark leading-tight mb-1.5 sm:mb-6 font-['DM_Sans',_sans-serif]" data-id="element-187">
        Tu cabeza no para,
        <br className="hidden sm:block" data-id="element-188" />
        tu lista no se achica
        <br className="hidden sm:block" data-id="element-189" /> y vos seguís sin poder arrancar.
      </motion.h1>

      {/* Subtitle */}
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="text-base sm:text-2xl text-gray-700 font-medium mb-3 sm:mb-10 max-w-3xl mx-auto font-['DM_Sans',_sans-serif]" data-id="element-190">
        No es falta de voluntad. No es pereza. Es química cerebral.
        <br data-id="element-191" />
        <span className="text-gold-600 font-bold" data-id="element-192">Y tiene solución.</span>
      </motion.h2>

      {/* Product Image */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="relative cursor-pointer group mb-3 sm:mb-12" onClick={scrollToCheckout} data-id="element-193">
        <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform -translate-y-10" data-id="element-194"></div>
        <img src="https://cdn.magicpatterns.com/uploads/m8Euxun3NC1Mdw2ikkZiUx/Emprendedor_Te_damos_una_solucion._(1080_x_1080_px)_(Post_de_Instagram_(45)).png" alt="Mega Kit Reset de Dopamina - Protocolo Neuromental Integral" className="relative w-full max-w-[260px] sm:max-w-lg mx-auto animate-float group-hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-195" />
      </motion.div>

      {/* Feature rows - hidden on mobile to fit above the fold */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.6
    }} className="hidden sm:block max-w-2xl mx-auto mb-8 sm:mb-10 space-y-3" data-id="element-196">
        <div className="bg-dark/5 backdrop-blur-sm rounded-xl p-4 flex items-start gap-3 text-left border border-gray-200/60" data-id="element-197">
          <Brain className="text-gold-500 shrink-0 mt-0.5" size={20} data-id="element-198" />
          <p className="text-sm sm:text-base text-gray-700" data-id="element-199">
            Si tenés 50 pestañas abiertas en la cabeza y sabés lo que tenés que
            hacer pero no podés arrancar.
          </p>
        </div>
        <div className="bg-dark/5 backdrop-blur-sm rounded-xl p-4 flex items-start gap-3 text-left border border-gray-200/60" data-id="element-200">
          <Zap className="text-gold-500 shrink-0 mt-0.5" size={20} data-id="element-201" />
          <p className="text-sm sm:text-base text-gray-700" data-id="element-202">
            <span className="font-bold text-dark" data-id="element-203">Rompé el ciclo:</span> Te vas
            a dormir con una mezcla rara de agotamiento y culpa, y el desorden
            de tu mente se come el desorden de tu vida.
          </p>
        </div>
        <div className="bg-dark/5 backdrop-blur-sm rounded-xl p-4 flex items-start gap-3 text-left border border-gray-200/60" data-id="element-204">
          <Shield className="text-gold-500 shrink-0 mt-0.5" size={20} data-id="element-205" />
          <p className="text-sm sm:text-base text-gray-700 font-[700]" data-id="element-206">
            <span className="font-bold text-dark" data-id="element-207"></span> Este sistema fue
            diseñado exactamente para vos.
          </p>
        </div>
      </motion.div>

      {/* CTA Button */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.8
    }} className="flex flex-col items-center max-w-lg mx-auto" data-id="element-208">
        <button onClick={scrollToCheckout} className="group relative w-full flex flex-col items-center justify-center px-5 sm:px-8 py-3.5 sm:py-5 text-base sm:text-lg font-bold text-white transition-all duration-200 bg-coral-500 rounded-2xl hover:bg-coral-600 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-coral-500 shadow-lg shadow-coral-500/30" data-id="element-209">
          <span className="flex items-center gap-2" data-id="element-210">👉 ACTIVAR MI RESET</span>
          <span className="text-xs sm:text-sm font-medium text-white/80 mt-0.5 sm:mt-1" data-id="element-211">
            Acceso inmediato · Descarga en segundos
          </span>
        </button>

        {/* Trust badges */}
        <div className="mt-3 sm:mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs sm:text-sm text-gray-500" data-id="element-212">
          <span className="flex items-center gap-1" data-id="element-213">
            <Lock size={12} data-id="element-214" /> Pago seguro
          </span>
          <span className="text-gray-300" data-id="element-215">·</span>
          <span className="flex items-center gap-1" data-id="element-216">
            <Download size={12} data-id="element-217" /> Descarga instantánea
          </span>
          <span className="text-gray-300" data-id="element-218">·</span>
          <span className="flex items-center gap-1" data-id="element-219">
            <MapPin size={12} data-id="element-220" /> PDF descargable
          </span>
        </div>
      </motion.div>
    </section>;
};